import React from 'react';
import {SvgIconProps} from '@material-ui/core/SvgIcon';
import {AccentColorOptions, useAccentColorStyle} from 'epic-ue-theme';
import {AccentProps, SvgIconColor} from './AccentedSvgIcon';

/**
 * This component is intended to wrap a Material UI Icon in order to allow for the UE accent colors
 *
 * Material UI documentation for Icons here: https://material-ui.com/components/icons/#material-icons
 */

interface AccentedMatProps extends AccentProps {
    children: React.ReactNode;
}

export type AccentedMatIconProps = AccentedMatProps | SvgIconProps;

export const AccentedMatIcon = (props: AccentedMatIconProps): JSX.Element => {
    const accentColor = props.color as AccentColorOptions;
    const {style, validAccentColor} = useAccentColorStyle(accentColor);

    /**
     * If a valid accent color is passed then we can reset the color prop into the Material Icon component.
     * The style prop will contain the color override for the accented color.
     */
    const color = validAccentColor ? 'inherit' : (props.color as SvgIconColor);

    const svgIconProps = props as SvgIconProps;
    const children = props.children;
    if (React.isValidElement(children)) {
        return React.cloneElement(children, Object.assign({}, svgIconProps, {style, color}));
    }
    return <i />;
};
